import { render, staticRenderFns } from "./Jokes.vue?vue&type=template&id=585a7a9e&scoped=true&"
import script from "./Jokes.vue?vue&type=script&lang=js&"
export * from "./Jokes.vue?vue&type=script&lang=js&"
import style0 from "./Jokes.vue?vue&type=style&index=0&id=585a7a9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585a7a9e",
  null
  
)

export default component.exports